<div class="body-vital-cont uni-body-vital-cont">
  <div *ngFor="let data of masterAttributeList;let i = index;">
    <ng-container *ngIf="(i !== 0 && tenantConfig?.tenant==='TRL') || tenantConfig?.tenant !== 'TRL'">
      <div [matTooltip]="data?.attributeName" class="att-ellipsis">
        <span>{{data?.attributeName | titlecase}}</span>
      </div>
      <div class="aligner">
        <div>
          <span class="special-font d-flex w-100 uni-special-font">
            <ng-container *ngIf="data?.attributeValue !== 'date'">
              <ng-container [ngSwitch]="data?.type">
                <ng-container *ngSwitchCase="'date'">
                  <span class="att-ellipsis pt-2 pb-2 d-inline-block"
                    matTooltip="{{ (data?.attributeValue | date:'dd-MMM-y hh:mm aaa':'en-US') ?? 'NA' }}">
                    {{ sharedService?.getLastSeenFormat(data?.attributeValue) ?? 'NA' }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <span class="att-ellipsis pt-2 pb-2 d-inline-block" [matTooltip]="data?.attributeValue">
                    {{ (data?.attributeValue || data?.attributeValue === 0 ) ? (tenantConfig?.tenant === 'VOT' ? getAttributeValue(data?.attributeValue) : data?.attributeValue) : 0 }}
                  </span>
                </ng-container>
              </ng-container>
            </ng-container>
            <span *ngIf="data?.attributeValue === 'date'" class="att-ellipsis pt-2 pb-2 d-inline-block"
              matTooltip="{{ currentTime | date:'dd-MMM-y hh:mm aaa':'en-US' }}">
              {{ sharedService?.getLastSeenFormat(currentTime) }}
            </span>
            &nbsp;
            <span class="uom pt-2 pb-2 d-inline-block">
              {{ (data?.attributeValue || data?.attributeValue === 0) ? data?.uom : '' }}
            </span>
          </span>
        </div>
        <div class="ml-auto position-relative">
          <img src="{{data?.attributeName==='No Data' ? data?.imgUrl:data?.imgUrl+token}}" [alt]="data?.attributeName"
            matTooltip="{{ data?.attributeName }}" />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="i===0 && tenantConfig?.tenant==='TRL'">
      <div matTooltip="Drive Score" class="att-ellipsis">
        <span>Drive Score</span>
      </div>
      <div class="aligner">
        <div><span class="special-font d-flex d-column w-100 uni-special-font"><span [style.color]="data?.color" class="att-ellipsis"
              matTooltip="{{driveScore}}">{{driveScore}}</span><span class="score-status"
              [ngClass]="driveScore > 1 ? 'harsh':'good'">
              <span>{{driveScore > 1?'Harsh':'Good'}}</span>
              <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.0813 5.32656C13.0265 5.15429 12.921 5.00258 12.7785 4.89132C12.636 4.78007 12.4633
                                        4.71447 12.2829 4.70312L9.03443 4.47891L7.8313 1.44375C7.7656 1.27663 7.65125 1.13307 7.50305
                                        1.03167C7.35485 0.93027 7.17962 0.875691 7.00005 0.875C6.82048 0.875691 6.64525 0.93027 6.49705
                                        1.03167C6.34885 1.13307 6.2345 1.27663 6.1688 1.44375L4.9438 4.49531L1.71724 4.70312C1.53705 4.71521
                                        1.36462 4.78108 1.22228 4.89223C1.07993 5.00338 0.974216 5.15468 0.9188 5.32656C0.861893 5.50108
                                        0.858568 5.68865 0.909254 5.86508C0.959941 6.0415 1.06231 6.1987 1.20318 6.31641L3.68599
                                        8.41641L2.94771 11.3203C2.89663 11.5168 2.90582 11.724 2.97409 11.9152C3.04236 12.1063
                                        3.16655 12.2725 3.33052 12.3922C3.48968 12.5064 3.6793 12.5706 3.87512 12.5764C4.07094
                                        12.5823 4.26405 12.5295 4.42974 12.425L6.99458 10.8008H7.00552L9.76724 12.5453C9.90891
                                        12.6374 10.0741 12.6867 10.243 12.6875C10.381 12.6864 10.5168 12.6537 10.6402 12.5919C10.7635
                                        12.5301 10.871 12.4409 10.9545 12.331C11.0379 12.2211 11.0951 12.0936 11.1215 11.9582C11.148
                                        11.8228 11.143 11.6832 11.1071 11.55L10.3251 8.37266L12.7969 6.31641C12.9378 6.1987 13.0402
                                        6.0415 13.0908 5.86508C13.1415 5.68865 13.1382 5.50108 13.0813 5.32656Z"
                  [ngStyle]="{'fill': driveScore > 1?'#C77B30':'#F5C916'}" />
              </svg>
            </span></span>
        </div>
        <div class="ml-auto position-relative"><img src="../../../../../assets/images/trl_drive_score_icon.svg"
            alt="drive score" matTooltip="Drive Score"></div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="entityDetails?.category === 'monotainer'">
    <div>Monotainer State</div>
    <div *ngIf="!monotainerState">No Data</div>
    <div class="aligner" *ngIf="monotainerState">
      <div><span class="special-font color-green uni-special-font">{{getStateLabel(monotainerState)}} </span></div>
      <div class="ml-auto position-relative"><img src="../../../../assets/images/mono-box.svg"></div>
    </div>
  </div>

  <div>
    <div>Alerts</div>
    <div class="aligner">
      <div><span class="special-font2 color-red active-link uni-alert-cont uni-special-font" matTooltip="Alert"
          (click)="activeAlertNavigation()">{{activeAlertsCount?
          activeAlertsCount: 0}}</span></div>
      <div class="ml-auto position-relative" matTooltip="Alert"><img [src]="tenantConfig?.alertWarningIcon ? tenantConfig.alertWarningIcon : '../../../../assets/images/alert-small.svg'"
          class="h-40">
      </div>
    </div>
  </div>
